import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

const basePath = process.env.VUE_APP_PATH;

export default createRouter({
  history:
    process.env.NODE_ENV === "production"
      ? createWebHistory(basePath)
      : createWebHashHistory(basePath),
  routes: [
    {
      path: "/:catchAll(.*)*",
      redirect: "/home",
    },
    {
      path: "/components",
      alias: "/components/index.html",
      name: "test",
      component: () => import("@/views/ComponentsTest.vue"),
    },
    {
      path: "/:page",
      alias: "/:page/index.html",
      name: "page",
      component: () => import("@/views/PageView.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ left: 0, top: 0 })
      }, 250)
    })
  },
});
